'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '数値を入力してください';